export default "__VITE_ASSET__D5f3ESy4__"